export const Status = new Map<number, {label: string}>([
  [1, {label: 'Assunto'}],
  [2, {label: 'Cessato'}],
])